var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueOutlineShirt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "blue-outline-shirt",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    fill: "#fff",
    stroke: "#3895f2",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shirt",
    transform: "translate(6 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M22,4.5H19.7c-.125-.125-1.35-1.355-1.355-1.355A.565.565,0,0,0,18,3H11.5a.5.5,0,0,0-.355.145L9.795,4.5H8a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.5A2,2,0,0,0,22,4.5Zm-3.88-.175.78.785L16.8,9.725,15.645,8.86ZM17.16,4,14.965,8,12.41,4Zm-5.745.3L14.33,8.88l-1.17.875L10.62,5.09ZM23,21a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V6.5a1,1,0,0,1,1-1H9.7l2.855,5.24a.5.5,0,0,0,.74.16L15,9.625,16.7,10.9a.5.5,0,0,0,.755-.195L19.82,5.5H22a1,1,0,0,1,1,1Z",
    transform: "translate(-6 -3)",
    fill: "#3895f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(8 8.5)",
    fill: "#3895f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(8 12)",
    fill: "#3895f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(8 15.5)",
    fill: "#3895f2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueOutlineShirt);
export default __webpack_public_path__ + "static/media/blue-outline-shirt.a8ebe572ca944ee6e7be6d14054e421b.svg";
export { ForwardRef as ReactComponent };